import React from "react";
import {
  withStyles,
  Button,
  Radio,
  RadioGroup,
  FormControlLabel,
} from "@material-ui/core";
import { compose } from "recompose";
import CustomSelect from "../components/CustomSelect";
import appConstant from "../../../../../appConstants";
import {
  isValid as isDateTimeValid,
  format,
  subDays,
  isSameDay,
} from "date-fns";
import {
  formatMonthDateYear,
  getUTCDate,
} from "../../../../dataGrid/gridUtilities";
import reportConstants from "../constants";
import { getDataWithQueryString } from "../../../../../api/componentAPIs";
import DateTimeEditor from "../components/DateTimeEditor";
import FieldError from "../components/FieldError";
import TextField from "../components/TextField";
import DateRangePicker from "../components/DateRangePicker";
import DateRangeInputBox from "../components/DateRangeInputBox";
import constants from "./constants";
const styles = (theme) => ({
  wrapper: {
    display: "flex",
    flexDirection: "column",
  },
  radioContainer: {
    margin: 16,
    width: "25%",
  },
  group: {
    marginTop: 16,
  },
  radio: {
    padding: 8,
    color : theme.TextColor
  },
  radioLabel : {
    color : theme.TextColor
  },
  headerLabel: {
    fontWeight: 600,
    color: theme.TextColor
  },
  controlsWrapper: {
    display: "flex",
    alignItems: "flex-start",
  },
  button: {
    width: "5%",
    margin: 12,
    marginTop: 16,
    '&$disabledButton':{
      backgroundColor: theme.iconColor,
    }
  },
  disabledButton:{

  },
  inputWidth: {
    marginTop: 10,
    width: 200,
    marginLeft: 12,
    marginRight: 12,
  },
  fieldContainer: {
    display: "flex",
    flexDirection: "column",
  },
  inputRangeContainer: {
    marginTop: 10,
    marginBottom: 8,
    marginLeft: 8,
  },
});

class InitialFilters extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchBy: null,
      filterSelections: {
        selectedTerminal: null,
        selectedDriver: null,
        dispatchDate: null,
        dateRange: [
          {
            startDate: subDays(new Date(), 1),
            endDate: subDays(new Date(), 1),
            key: "selection",
          },
        ],
      },
      fiterSelectionsErrorInfo: {
        selectedTerminal: null,
        selectedDriver: null,
        dispatchDate: null,
        dateRange: null,
      },
      terminalList: [],
      openCalendar: false,
    };
  }

  componentDidMount() {
    getDataWithQueryString("GetAllTerminals").then((response) => {
      if (response && response.status >= 200 && response.status < 400) {
        this.setState({
          terminalList: response.data.map((terminal) => ({
            value: terminal.terminalCode,
            label: terminal.terminalCode,
          })),
        });
      }
    });
  }

  handleChange = (name) => (value) => {
    this.setState((prevState) => ({
      filterSelections: {
        ...prevState.filterSelections,
        [name]: value,
      },
      fiterSelectionsErrorInfo: {
        ...prevState.fiterSelectionsErrorInfo,
        [name]: this.getFieldError(name, value),
      },
    }));
  };

  onDateRangeChange = (ranges) => {
    const { selection } = ranges;
    this.handleChange("dateRange")([selection]);
  };

  closeDateRangePicker = () => {
    this.setState({ openCalendar: false });
  };

  updateSearchByFilter = (event) => {
    this.setState({ searchBy: event.target.value });
  };

  applyFilters = () => {
    const error = Object.values(this.getErrorInfo()).filter(
      (value) => value
    ).length;
    if (!error) {
      this.props.renderReport(this.state.searchBy, this.getFilterSelections());
    }
  };

  getFieldError = (fieldName, value) => {
    switch (fieldName) {
      case "selectedTerminal":
        return this.getTerminalError(value);
      case "dispatchDate":
        return this.getDispatchDateError(value);
      case "selectedDriver":
        return this.getDriverError(value);
      case "dateRange":
        return this.getDateRangeError(value);
      default:
        return null;
    }
  };

  getErrorInfo = () => {
    let fiterSelectionsErrorInfo = {};
    Object.keys(this.state.filterSelections).forEach((fieldName) => {
      fiterSelectionsErrorInfo[fieldName] = this.getFieldError(
        fieldName,
        this.state.filterSelections[fieldName]
      );
    });
    this.setState({
      fiterSelectionsErrorInfo,
    });
    return fiterSelectionsErrorInfo;
  };

  getTerminalError = (value) => {
    const { searchBy } = this.state;
    if (searchBy === reportConstants.REPORT_TYPES.TERMINAL) {
      return value ? null : "* Required";
    }
    return null;
  };

  getDriverError = (value) => {
    const { searchBy } = this.state;
    if (searchBy === reportConstants.REPORT_TYPES.DRIVER) {
      return value ? null : "* Required";
    }
    return null;
  };

  getDispatchDateError = (date) => {
    const { searchBy } = this.state;
    if (searchBy === reportConstants.REPORT_TYPES.TERMINAL) {
      if (!date) {
        return "* Required";
      }
      return date && isDateTimeValid(date) ? null : "Invalid date";
    }
    return null;
  };

  getDateRangeError = (date) => {
    const { searchBy } = this.state;
    if (searchBy === reportConstants.REPORT_TYPES.DRIVER) {
      if (!date[0].startDate || !date[0].endDate) {
        return "* Required";
      }
    }
    return null;
  };

  getFilterSelections = () => {
    const { searchBy, filterSelections } = this.state;
    const { selectedTerminal, dispatchDate, selectedDriver, dateRange } =
      filterSelections;
    if (searchBy === reportConstants.REPORT_TYPES.TERMINAL) {
      return {
        terminalCode: selectedTerminal.value,
        dispatchDate: format(
          getUTCDate(dispatchDate),
          reportConstants.APP_DATE_FORMAT
        ),
      };
    }
    const { startDate, endDate } = dateRange[0];
    return {
      driver: selectedDriver,
      startDate: format(startDate, reportConstants.APP_DATE_FORMAT),
      endDate: format(endDate, reportConstants.APP_DATE_FORMAT),
    };
  };

  onDateChanged = (name) => (value) => {
    if (!value) {
      this.handleChange(name)(value);
      return;
    }
    if (value && isDateTimeValid(value)) {
      this.handleChange(name)(value);
    }
  };

  openCalendar = () => {
    this.setState({
      openCalendar: true,
    });
  };

  render() {
    const { classes } = this.props;
    const {
      searchBy,
      fiterSelectionsErrorInfo,
      filterSelections,
      openCalendar,
    } = this.state;
    const { selectedTerminal, selectedDriver, dateRange } = filterSelections;
    const dispatchDate = formatMonthDateYear({
      value: filterSelections.dispatchDate,
    });
    const currentDate = new Date();
    return (
      <div className={classes.wrapper}>
        <div className={classes.radioContainer}>
          <span className={classes.headerLabel}>Search By</span>
          <RadioGroup
            aria-label="Search_By"
            name="searchBy"
            className={classes.group}
            value={searchBy}
            onChange={this.updateSearchByFilter}
          >
            {reportConstants.SEARCH_BY_OPTIONS.map(({ label, value }) => (
              <FormControlLabel
                value={value}
                control={<Radio className={classes.radio} color="primary" />}
                label={label}
                key={`radio_${label}`}
                classes={{ label: classes.radioLabel }}
              />
            ))}
          </RadioGroup>
        </div>
        <div className={classes.controlsWrapper}>
          {searchBy === reportConstants.REPORT_TYPES.TERMINAL && (
            <>
              <div>
                <CustomSelect
                  themed={true}
                  placeholder="Select Terminal"
                  name="selectedTerminal"
                  value={selectedTerminal}
                  onChange={this.handleChange("selectedTerminal")}
                  options={this.state.terminalList}
                  isClearable
                />
                {fiterSelectionsErrorInfo.selectedTerminal && (
                  <FieldError
                    error={fiterSelectionsErrorInfo.selectedTerminal}
                  />
                )}
              </div>
              <div>
                <DateTimeEditor
                  dateType={appConstant.DATETYPES.MONTHDATEYEAR}
                  onChange={this.onDateChanged("dispatchDate")}
                  disableFuture={true}
                  value={dispatchDate}
                  maxDate={currentDate.setDate(currentDate.getDate() - 1)}
                />
                {fiterSelectionsErrorInfo.dispatchDate && (
                  <FieldError error={fiterSelectionsErrorInfo.dispatchDate} />
                )}
              </div>
            </>
          )}
          {searchBy === reportConstants.REPORT_TYPES.DRIVER && (
            <>
              <div className={classes.fieldContainer}>
                <TextField
                  id="driverInput"
                  label="Driver number"
                  handleChange={this.handleChange("selectedDriver")}
                  value={selectedDriver ?? ""}
                  className={classes.inputWidth}
                  autoFocus
                />
                {fiterSelectionsErrorInfo.selectedDriver && (
                  <FieldError error={fiterSelectionsErrorInfo.selectedDriver} />
                )}
              </div>

              <div className={classes.fieldContainer}>
                {!openCalendar &&
                  dateRange[0].startDate &&
                  dateRange[0].endDate && (
                    <div className={classes.inputRangeContainer}>
                      <DateRangeInputBox
                        startDate={format(
                          dateRange[0].startDate,
                          reportConstants.REPORT_DISPLAY_DATE_FORMAT
                        )}
                        endDate={format(
                          dateRange[0].endDate,
                          reportConstants.REPORT_DISPLAY_DATE_FORMAT
                        )}
                        onClick={this.openCalendar}
                      />
                    </div>
                  )}
                {openCalendar && (
                  <DateRangePicker
                    rangeColors={["#05a792"]}
                    onChange={this.onDateRangeChange}
                    showSelectionPreview={true}
                    moveRangeOnFirstSelection={false}
                    months={1}
                    startDatePlaceholder="From"
                    endDatePlaceholder="To"
                    maxDate={subDays(new Date(), 1)}
                    ranges={dateRange}
                    inputRanges={[]}
                    dateDisplayFormat={
                      reportConstants.REPORT_DISPLAY_DATE_FORMAT
                    }
                    direction="vertical"
                    editableDateInputs
                    color="#05a792"
                    handleClose={this.closeDateRangePicker}
                    staticRanges={constants.STATIC_DATE_RANGE_LIST.map(
                      ({ label, value }) => ({
                        label,
                        range: () => ({
                          startDate: subDays(new Date(), value),
                          endDate: subDays(new Date(), 1),
                        }),
                        isSelected(range) {
                          const definedRange = this.range();
                          return (
                            isSameDay(
                              range.startDate,
                              definedRange.startDate
                            ) && isSameDay(range.endDate, definedRange.endDate)
                          );
                        },
                      })
                    )}
                  />
                )}
                {fiterSelectionsErrorInfo.dateRange && (
                  <FieldError error={fiterSelectionsErrorInfo.dateRange} />
                )}
              </div>
            </>
          )}
        </div>
        <Button
          variant="contained"
          color="primary"
          size="small"
          disabled={!searchBy}
          classes={{ root: classes.button, disabled: classes.disabledButton }}
          onClick={this.applyFilters}
        >
          Apply
        </Button>
      </div>
    );
  }
}
export default compose(withStyles(styles))(InitialFilters);
